import { render, staticRenderFns } from "./OfferDetailCard.vue?vue&type=template&id=2de1e75e&scoped=true"
import script from "./OfferDetailCard.vue?vue&type=script&lang=ts"
export * from "./OfferDetailCard.vue?vue&type=script&lang=ts"
import style0 from "./OfferDetailCard.vue?vue&type=style&index=0&id=2de1e75e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de1e75e",
  null
  
)

export default component.exports